import {TranslateService} from "@ngx-translate/core";
import {NotificationService, UserStore} from "@digicerba/common";
import {IAlerteWebServiceClient, LigneDossierDto, SaveAlerteDto, UserInformations} from "@resources/resources";
import {AsiDialogView} from "@asi-ngtools/lib";
import {Component} from "@angular/core";

@Component({
  selector: 'planifier-alerte-modal',
  templateUrl: './planifier-alerte.modal.html',
})
export class PlanifierAlerteModal extends AsiDialogView {

  public dossiers: Array<LigneDossierDto>;
  public hoursRange: Array<{ code: string, label: string }>;

  user: UserInformations;
  hourRange: string;

  constructor(userStore: UserStore, private alerteWebServiceClient: IAlerteWebServiceClient, private notificationService: NotificationService,
              private translate: TranslateService) {
    super();
    this.user = userStore.getUser();
    this.hoursRange = new Array();
    this.hoursRange.push({
      code: 'ALL',
      label: this.translate.instant('PAGE.SERVEUR-RESULTATS.DIALOG.PLAGE_HORAIRE_ALL')
    });
    this.hoursRange.push({
      code: 'DAY',
      label: this.translate.instant('PAGE.SERVEUR-RESULTATS.DIALOG.PLAGE_HORAIRE_DAY')
    });
    var params = {from: '', to: ''};
    for (var i = 0; i < 24; i++) {
      params['from'] = '' + i;
      params['to'] = '' + (i + 1);
      if (i == 23) {
        params['to'] = '0';
      }
      this.hoursRange.push({
        code: '' + i,
        label: this.translate.instant('PAGE.SERVEUR-RESULTATS.DIALOG.PLAGE_HORAIRE_HOUR_FROM_TO', params)
      });
    }

  }

  enregistrerAlerteSms() {
    let alertes: Array<SaveAlerteDto> = [];
    this.dossiers.forEach(dossier => {
      let alerte: SaveAlerteDto = new SaveAlerteDto();
      alerte.telephone = this.user.telephone;
      alerte.idDossier = dossier.identifiant;
      this.assignPlageHoraire(alerte, this.hourRange);
      alertes.push(alerte);
    });
    this.alerteWebServiceClient.enregistrerAlertes(alertes).subscribe(() =>
      this.notificationService.showSuccessNotification("PAGE.REEMISSION.success")
    );
    this.dialog.close();
  }

  enregistrerAlerteEmail() {
    let alertes: Array<SaveAlerteDto> = [];
    this.dossiers.forEach(dossier => {
      let alerte: SaveAlerteDto = new SaveAlerteDto();
      alerte.email = this.user['e-mail'];
      alerte.idDossier = dossier.identifiant;
      this.assignPlageHoraire(alerte, this.hourRange);
      alertes.push(alerte);
    });
    this.alerteWebServiceClient.enregistrerAlertes(alertes).subscribe(() =>
      this.notificationService.showSuccessNotification("PAGE.REEMISSION.success")
    );
    this.dialog.close();
  }

  fermer() {
    this.dialog.cancel();
  }

  assignPlageHoraire(alerte: SaveAlerteDto, plageHoraireValue: any) {
    if (plageHoraireValue) {
      if (plageHoraireValue.code === 'ALL') {
        alerte.heureEnvoiDebut = null;
        alerte.heureEnvoiFin = null;
      } else if (plageHoraireValue.code === 'DAY') {
        alerte.heureEnvoiDebut = 7;
        alerte.heureEnvoiFin = 19;
      } else {
        alerte.heureEnvoiDebut = Number.parseInt(plageHoraireValue.code);
        alerte.heureEnvoiFin = Number.parseInt(plageHoraireValue.code) + 1;
      }
    }
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-serveur-resultats/digicerba-serveur-resultats-web/src/angular/cerba/src/app/pages/cerba/pages/planifier-alerte-modal/planifier-alerte.modal.ts